import { ModelBase } from 'store/model-base';

export class LineLockStatus extends ModelBase {
    public static storeName: string = 'lineLockStatus';

    public mdnLockEnabled: boolean;
    public mdn: string;
    public lockReasonCode: string;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: LineLockStatus = super.create<LineLockStatus>(initData);

        return super.create<T>(toReturn);
    }
}
